export default __webpack_public_path__ + "static/media/nsc-img3.a8adb3ea.png";